<div fxLayout="row" fxHide fxShow.gt-sm style="margin-bottom: 10px;background-color:#2d2f31;color: white; width: 100%;">

    <div fxLayout="row" style="width: 100%; height: 100%;" fxLayoutAlign="space-evenly center">

        <div (click)="back()" fxLayoutAlign="center center" class="back pointer">
            <mat-icon>keyboard_backspace</mat-icon>
        </div>

        <div class="logo">
            <calsoft-logo fxflex="100"></calsoft-logo>
        </div>

        <div class="subjectname">
            <span [innerHTML]="product.name" class="break-word"></span>
        </div>


        <div>
            <button class="action-button" (click)="reviewPopup()">Rating</button>
        </div>



        <div class="cup-icon-container">
            <svg class="progress-circle" viewBox="0 0 36 36">
                <path class="circle-bg" d="M18 2.0845
                       a 15.9155 15.9155 0 0 1 0 31.831
                       a 15.9155 15.9155 0 0 1 0 -31.831" />

                <path class="circle" [attr.stroke-dasharray]="'100, 100'"
                    [attr.stroke-dashoffset]="100 - courseCompletedPercentage" transform="rotate(-90, 18, 18)" d="M18 2.0845
                       a 15.9155 15.9155 0 0 1 0 31.831
                       a 15.9155 15.9155 0 0 1 0 -31.831" />

            </svg>
            <div class="icon-container">
                <mat-icon>emoji_events</mat-icon>
            </div>
        </div>

        <div>
            <button class="action-button1" [matMenuTriggerFor]="CertificteMenu">Get a certificate</button>
        </div>

        <button [matMenuTriggerFor]="menu" mat-icon-button>
            <mat-icon>share</mat-icon>
            <span>Share</span>
        </button>

        <mat-menu #CertificteMenu="matMenu">
            <div fxLayout="row" style="padding: 15px;" fxLayoutAlign="center center" fxLayoutGap="10px">
                <div style="color: black;">
                    <p>Completed Section: {{ courseCompletedSection }} out of {{ totalCourseItem }}</p>

                    <button style="color:white" class="inner-button"
                        [disabled]="courseCompletedPercentage < certificateEnablePercentage" mat-raised-button
                        (click)="generate()"> {{btndownload}}
                        <mat-icon *ngIf="btndownload !='Get a Certificate'" style="color: white;">
                            <mat-spinner diameter="20">
                            </mat-spinner>
                        </mat-icon>
                    </button>

                    <div *ngIf="initCourseCertificate">

                        <div #htmlData>
                            <div *ngIf="certificateType==0">
                                <calsoft-certificate-no1 #certificateComponent [product]="product" [Lecture]="Lecture"
                                    [data]="data"></calsoft-certificate-no1>
                            </div>


                            <div *ngIf="certificateType==1">
                                <calsoft-certificate-no2 #certificateComponent [product]="product" [Lecture]="Lecture"
                                    [data]="data"></calsoft-certificate-no2>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </mat-menu>

        <mat-menu #menu="matMenu">
            <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px">
                <div class="padding-10" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px">
                    <button (click)="copy()" class="shareIcon" mat-icon-button>
                        <mat-icon style="color: gray">content_copy</mat-icon>
                        <span>
                            Copy
                        </span>
                    </button>
                </div>
            </div>
        </mat-menu>
    </div>

</div>

<div fxLayout="row" fxHide fxShow.lt-sm
    style="margin-bottom: 10px;background-color:#2d2f31;color: white; width: 100%;height: auto;padding:5px;">
    <div fxLayout="row" style="width: 100%;" fxLayoutAlign="start center">
        <div (click)="back()" fxLayoutAlign="center center" class="back">
            <mat-icon>keyboard_backspace</mat-icon>
        </div>

        <div fxLayoutAlign="center center">
            <span [innerHTML]="product.name"></span>
        </div>
    </div>
</div>


<div *ngIf="initCourse" fxLayoutAlign.gt-md="center start" class="container" fxLayout="row" fxLayout.xs="column"
    fxLayoutGap="10px">

    <div class="content-70" [fxFlex.gt-md]="isExpanded ? 100 : 70" fxFlex.xs="100">

        <div fxLayout="column">

            <div fxLayout="row" fxLayoutAlign="center center" class="overSize" [ngClass]="{'video-container': isMobile}"
                style="background-color: #2d2f31; color: white;height: auto; overflow-y: auto;">
                <div *ngIf="isExpanded" class="arrow-right-container">
                    <button (click)="closeExpanded()" type="button"
                        class="ud-btn ud-btn-large ud-btn-primary ud-heading-md course-content-toggle--button--k2Aq3 snipcss-ilstk">

                        <mat-icon class="ud-icon ud-icon-medium">arrow_back_ios</mat-icon>
                        <span style="font-size: 14px;" aria-label="Open Course content sidebar"
                            class="course-content-toggle--label--wcscS">Course
                            content</span></button>
                </div>

                <div>

                    <button (click)="moveLeft()" class="arrow-left-container1">
                        <mat-icon class="backgrey">arrow_back_ios</mat-icon>
                    </button>

                    <button (click)="moveRight()" class="arrow-right-container1">
                        <mat-icon class="backgrey">arrow_forward_ios</mat-icon>
                    </button>

                </div>

                <div *ngIf="type==1" fxFlex="100" fxLayoutAlign="center center">
                    <!-- <video #videoPlayer oncanplay="this.play()" onloadedmetadata="this.muted = true"
                    [ngStyle.lt-md]="{height:height==0?'auto':productDetailHeightMobile,width:width==0?'auto':productDetailWidthMobile}"
                    [ngStyle.gt-sm]="{height:height==0?'auto':productDetailHeight,width:width==0?'auto':productDetailWidth}" muted controls
                        (ended)="moveRight()" controlsList="nodownload" (timeupdate)="onTimeUpdate($event)"
                        disablePictureInPicture class="responsive-video">
                        <source [src]="serverPath + value">
                    </video> -->

                    <video #videoPlayer oncontextmenu="return false;" (touchstart)="disableDownload($event)" muted controls
                    controlsList="nodownload" (ended)="moveRight()" (timeupdate)="onTimeUpdate($event)"
                    disablePictureInPicture class="responsive-video"
                    [ngStyle.lt-md]="{height:height==0?'auto':productDetailHeightMobile,width:width==0?'auto':productDetailWidthMobile}"
                    [ngStyle.gt-sm]="{height:height==0?'auto':productDetailHeight,width:width==0?'auto':productDetailWidth}">
                    <source [src]="serverPath + value">
                </video>
                </div>

                <div     [ngStyle.lt-md]="{height:height==0?'auto':productDetailHeightMobile,width:width==0?'auto':productDetailWidthMobile}"
                [ngStyle.gt-sm]="{height:height==0?'auto':productDetailHeight,width:width==0?'auto':productDetailWidth}" *ngIf="type==8" fxLayoutAlign="center center">
                    <audio   fxLayoutAlign="center center" #videoPlayer oncanplay="this.play()" onloadedmetadata="this.muted = true"
                       muted controls
                        (ended)="onVideoEnded()" controlsList="nodownload" (timeupdate)="onTimeUpdate($event)" controls>
                        <source [src]="serverPath2 + value">
                    </audio>
                </div>
 
                <div *ngIf="type==7" fxFlex="100" class="overflow-container">
                    <p [innerHTML]="value"  class="padding-20 text-color"></p>
                </div>


                <div *ngIf="type==6" fxFlex="100" fxLayoutAlign="center center">
                    <iframe   [ngStyle.lt-md]="{height:height==0?'auto':productDetailHeightMobile,width:width==0?'auto':productDetailWidthMobile}"
                    [ngStyle.gt-sm]="{height:height==0?'auto':productDetailHeight,width:width==0?'auto':productDetailWidth}"
                        [src]="youtubeUrl + value + '?autoplay=1' | safe: 'resourceUrl'" frameborder="0"
                        allow="autoplay"></iframe>
                </div>

                <div *ngIf="type==3" fxLayoutAlign="center center">
                    <img class="padding-20"
                    [ngStyle.lt-md]="{height:height==0?'auto':productDetailHeightMobile,width:width==0?'auto':productDetailWidthMobile}"
                    [ngStyle.gt-sm]="{height:height==0?'auto':productDetailHeight,width:width==0?'auto':productDetailWidth}"
                        [src]="serverPath1+value" />
                </div>
                <div    [ngStyle.lt-md]="{height:height==0?'auto':productDetailHeightMobile,width:width==0?'auto':productDetailWidthMobile}"
                [ngStyle.gt-sm]="{height:height==0?'auto':productDetailHeight,width:width==0?'auto':productDetailWidth}" *ngIf="type==2" fxLayoutAlign="center center" class="pdfbtn-container" fxFlex="100">

                    <!-- <calsoft-pdf-viewer  style="width: 100%" [path]="'/coursepdf/'" [fileName]="value"></calsoft-pdf-viewer> -->
                    <button class="pdfbtn" mat-button mat-stroked-button (click)="downloadPdf(value)">Download
                        Pdf</button>
                </div>
                <div     [ngStyle.lt-md]="{height:height==0?'auto':productDetailHeightMobile,width:width==0?'auto':productDetailWidthMobile}"
                [ngStyle.gt-sm]="{height:height==0?'auto':productDetailHeight,width:width==0?'auto':productDetailWidth}" *ngIf="type==9" fxLayoutAlign="center center" style="width: 100%;">
                    <app-quiz [courseHistory]="courseHistory"  [primaryIndex]="primaryIndex"  [secondaryIndex]="secondaryIndex" [courseText]="courseText"
      [productId]="productId" [quizid]="value" style="width: 100%;" (onsubmitquiz)="callright($event)"></app-quiz>
                </div>

            </div>

            <div>

                <div class="claassOverview" style="margin-top: 10px;">
                    <mat-tab-group>

                        <div *ngIf="!displayCourse">
                            <mat-tab  label="Course Content">

                                <div>
                                    <div *ngFor="let section of courseText; let i = index">
    
                                        <div fxLayout="row">
                                            <div (click)="toggleAccordion(i)" class="pointer" fxFlex="100" fxLayoutAlign="center center" style="background: #f7f9fa;
                                           border-bottom: 1px solid #d1d7dc;padding: 10px;">
                                                <span fxFlex="100" class="couserTitle f-weight">
                                                    {{section.title}}</span>
                                                <button *ngIf="accordionOpenIndex !== i" mat-icon-button>
                                                    <mat-icon>keyboard_arrow_down</mat-icon>
                                                </button>
                                                <button *ngIf="accordionOpenIndex === i" mat-icon-button>
                                                    <mat-icon>keyboard_arrow_up</mat-icon>
                                                </button>
                                            </div>
                            
                                        </div>
                            
                            
                            
                            
                                        <div fxLayout="column" *ngIf="accordionOpenIndex === i">
                                            <div *ngFor="let subsection of section.courseItem; let j = index" fxFlex="100" fxLayout="row wrap"
                                                style="border: 1px solid lightgray;"
                                                [ngClass]="{'active-subsection': primaryIndex === i && secondaryIndex === j}">
                                                <div (click)="getVideoData(subsection, i, j,1)" *ngIf="subsection.type!=0" fxLayout="column" style="
                                                padding: 10px;">
                                                    <div class="pointer" fxFlex="100" fxLayout="row">
                                                        <div (click)="getVideoData(subsection, i, j , 1)" fxLayoutAlign="space betweeen center"
                                                            fxFlex="100">
                                                            <span fxFlex="100" class="couserTitle f-weight">
                                                                {{subsection.title}}</span>
                            
                                                        </div>
                            
                            
                                                    </div>
                            
                                                    <div fxLayout="row">
                                                        <span *ngIf="subsection.type==1"><mat-icon
                                                                style="font-size: 16px;">ondemand_video</mat-icon></span>
                                                        <span *ngIf="subsection.type==3"><mat-icon style="font-size: 16px;">image</mat-icon></span>
                                                        <span *ngIf="subsection.type==6"><mat-icon
                                                                style="font-size: 16px;">ondemand_video</mat-icon></span>
                                                        <span *ngIf="subsection.type==7"><mat-icon style="font-size: 16px;">draft</mat-icon></span>
                                                        <span *ngIf="subsection.type==2"><mat-icon
                                                                style="font-size: 16px;">picture_as_pdf</mat-icon></span>
                                                        <span *ngIf="subsection.type==8"><mat-icon
                                                                style="font-size: 16px;">audio_file</mat-icon></span>
                                                        <span *ngIf="subsection.type==0"></span>
                                                    </div>
                                                </div>
                            
                                            </div>
                                        </div>
                                    </div>
                                </div>
    
                            </mat-tab>
                        </div>
                     

                        <mat-tab label="Overview">



                            <div class="productName">

                                <div class="padding-tb10" *ngIf="name.length>0">
                                    <calsoft-translator [translateValue]="name"
                                        [type]="'productsdetails'"></calsoft-translator>
                                </div>

                                <div class="Reviews">
                                    <calsoft-star-rate [averageRating]="averageRating"
                                        [calculateAvgRating]="calculateAvgRating"></calsoft-star-rate>
                                </div>

                                <div class="lastEdition">

                                </div>

                                <div class="language">

                                </div>

                            </div>

                            <div>

                                <div class="spec-table" *ngIf="initShortDescription">
                                    <div>
                                        <h2>What you'll learn</h2>
                                    </div>
                                    <div *ngFor="let item of shortDescription.split(',,')">
                                        <div fxLayout="row" fxLayoutAlign="start center">
                                            <mat-icon fxFlex="none" class="maticoncss"
                                                style="margin-right: 8px;">check_circle</mat-icon>
                                            <span class="spec-value" [innerHTML]="item.trim()">
                                            </span>
                                        </div>
                                    </div>
                                </div>


                                <!-- <div>
                                    <h2 class="spec-table-header">What you'll learn</h2>
                                    <p [innerHTML]="shortDescription"></p>

                                </div> -->


                            </div>

                            <div class="padding-tb10">
                                <div fxLayout="column">
                                    <div fxLayout="row">
                                        <h2 class="spec-table-header">Description</h2>
                                    </div>

                                    <div fxLayout="row">
                                        <p [innerHTML]="description"> </p>
                                    </div>



                                </div>
                            </div>

                        </mat-tab>

                        <mat-tab label="Notes">

                            <div class="padding-10">

                                <div class="editSets1">
                                    <div class="title " fxLayout="row" fxLayoutAlign="center center">
                                        <span>Notes</span>
                                    </div>
                                </div>

                                <div class="padding-10" style="background-color: gray;" fxLayout="column"
                                    fxLayoutAlign="center center">
                                    <mat-icon> insert_drive_file</mat-icon>

                                    <div style="color: white;" class="title padding-10">
                                        Add Notes For Future Reference!
                                    </div>

                                    <div class="create Note">
                                        <button mat-flat-button color="primary" (click)="createNote(null, 0)">
                                            <span class="medium-x">Create Note</span>
                                        </button>
                                    </div>
                                </div>

                                <br>

                                <table *ngIf="noteList.length>0">

                                    <tr>
                                        <th class="trbg">Notes</th>
                                        <th class="trbg">Created Date</th>
                                        <th class="trbg">Updated Date</th>
                                        <th class="trbg">Action</th>
                                    </tr>
                                    <tr *ngFor="let note of noteList;">

                                        <td>
                                            <span  class="truncate-text">
                                                {{note.notes}}
                                            </span></td>
                                        <td>{{note.createdDate | date:'dd-MM-yyyy'}}</td>
                                        <td>{{note.updatedDate | date:'dd-MM-yyyy'}}</td>

                                        <td>
                                            <button mat-icon-button [matMenuTriggerFor]="menu">
                                                <mat-icon>more_vert</mat-icon>
                                            </button>
                                            <mat-menu #menu="matMenu">
                                                <button style="width: 115px;" (click)="createNote(note,note.noteId)"
                                                    mat-menu-item>
                                                    <mat-icon>edit</mat-icon>
                                                    Edit
                                                </button>

                                            </mat-menu>
                                        </td>
                                    </tr>

                                </table>



                            </div>


                        </mat-tab>

                        <mat-tab label="Reviews"  fxFlex="100">
                            <div>
                                <div class="ratings">
                                    <div fxHide fxShow.lt-sm fxShow.lt-md fxShow.lt-lg>
                                        <button (click)="reviewPopup()" class="reviewbutton">Review
                                            Course</button>
                                    </div>
                                    <calsoft-review-rating [type]="2"
                                        [reviewDetail]="reviewDetail"></calsoft-review-rating>
                                </div>
                            </div>


                        </mat-tab>

                    </mat-tab-group>
                </div>
            </div>

        </div>

    </div>

    <div fxHide fxShow.gt-md style="width: 100%;" *ngIf="!isExpanded" class="content-30" fxFlex="100" fxFlex.gt-md="30">


        <div class="coourserContent">

            <div fxLayout="column">
                <div style="background: white;
                border: 0.5px solid rgb(231, 228, 228);padding: 10px;" fxLayout="row"
                    fxLayoutAlign="space-between center">
                    <span>
                        Course Content
                    </span>
                    <button (click)="toggleFlex()" mat-icon-button>
                        <mat-icon>close</mat-icon>
                    </button>
                </div>

            </div>




        </div>

        <div *ngFor="let section of courseText; let i = index">

            <div fxLayout="row">
                <div (click)="toggleAccordion(i)" class="pointer" fxFlex="100" fxLayoutAlign="center center" style="background: #f7f9fa;
               border-bottom: 1px solid #d1d7dc;padding: 10px;">
                    <span fxFlex="100" class="couserTitle f-weight">
                        {{section.title}}</span>
                    <button *ngIf="accordionOpenIndex !== i" mat-icon-button>
                        <mat-icon>keyboard_arrow_down</mat-icon>
                    </button>
                    <button *ngIf="accordionOpenIndex === i" mat-icon-button>
                        <mat-icon>keyboard_arrow_up</mat-icon>
                    </button>
                </div>

            </div>




            <div fxLayout="column" *ngIf="accordionOpenIndex === i">
                <div *ngFor="let subsection of section.courseItem; let j = index" fxFlex="100" fxLayout="row wrap"
                    style="border: 1px solid lightgray;"
                    [ngClass]="{'active-subsection': primaryIndex === i && secondaryIndex === j}">
                    <div (click)="getVideoData(subsection, i, j,1)" *ngIf="subsection.type!=0" fxLayout="column" style="
                    padding: 10px;">
                        <div class="pointer" fxFlex="100" fxLayout="row">
                            <div (click)="getVideoData(subsection, i, j , 1)" fxLayoutAlign="space betweeen center"
                                fxFlex="100">
                                <span fxFlex="100" class="couserTitle f-weight">
                                    {{subsection.title}}</span>

                            </div>


                        </div>

                        <div fxLayout="row">
                            <span *ngIf="subsection.type==1"><mat-icon
                                    style="font-size: 16px;">ondemand_video</mat-icon></span>
                            <span *ngIf="subsection.type==3"><mat-icon style="font-size: 16px;">image</mat-icon></span>
                            <span *ngIf="subsection.type==6"><mat-icon
                                    style="font-size: 16px;">ondemand_video</mat-icon></span>
                            <span *ngIf="subsection.type==7"><mat-icon style="font-size: 16px;">draft</mat-icon></span>
                            <span *ngIf="subsection.type==2"><mat-icon
                                    style="font-size: 16px;">picture_as_pdf</mat-icon></span>
                            <span *ngIf="subsection.type==8"><mat-icon
                                    style="font-size: 16px;">audio_file</mat-icon></span>
                            <span *ngIf="subsection.type==0"></span>
                        </div>
                    </div>

                </div>
            </div>
        </div>


    </div>

</div>